// import ImgAuthority from '@/sealFilter/ImgAuthority'
import {getRequest,postRequest, requestAuthority } from '@/sealFilter/requestAuthority'

// 公共馆、高校馆-中图分类
let listclassifyTypes=(data)=>postRequest('/classify/search/action/list',data);
// 大众分类
let listpopularTypes=(data)=>postRequest('/popularTypes/search/action/list',data);
// 学科分类
let searchlist=(data)=>postRequest('/subject/search/action/list',data);

let actionall=(data)=>postRequest('/home/action/all',data);

export{
  listclassifyTypes,listpopularTypes,searchlist,actionall
}
// 图片上传 图片上传和上面两个接口的端口是不一样的
export function actionuploadImg (data) {
  return requestAuthority({
    url: '/pubcom/pb/common/action/uploadImg',
    method: 'post',
    data
  })
}


// 公共馆-通俗分类[大众分类]
// export function listpopularTypes (data) {
//   return requestAuthority({
//     url: 'pubcom/pb/popularTypes/action/search/child?level=3&gid=-1',
//     method: 'GET',
//     params: data
//   })
// }



// 出版社数目
export function searchpage (data) {
  return requestAuthority({
    url: '/pubcom/pb/orgs/action/search/page?orgType=3&sortRule=%7B"province"%3A"desc"%7D',
    method: 'GET',
    params: data
  })
}
// http://220.249.72.252:27301/v2/pubcom/pb/orgs/action/search/page?orgType=3&pageNum=1&province=湖南省 
// 商品页通过省获取到不同的商品
export function searchpageCity (data) {
  return requestAuthority({
    url: '/pubcom/pb/orgs/action/search/page',
    method: 'GET',
    params: data
  })
}
// 商品页通过出版社获取介绍
export function searchbyGid (data) {
  return requestAuthority({
    url: '/pubcom/pb/orgs/action/search/byGid',
    method: 'GET',
    params: data
  })
}





// WEBPACK FOOTER //
// ./src/api/img.js